import React, { useState } from "react"
import SectionHeader from "blocks/SectionHeader"
import Accordion from "blocks/Accordion"
import { relatedNews as relatedQuery } from "./News/query"
import NewsModule from "blocks/NewsModule"

export default ({ heading, current, relatedTo, type, limit = 6, color = "light-gray", storyType = null, hasSearchBar = false }) => {
  const [searchQuery, setSearchQuery] = useState(null);

  return <section className="pad-top pad-bottom max-width">
    <SectionHeader heading={heading} />

    {hasSearchBar && <SearchEntries searchQuery={(value) => {
      setSearchQuery(value)
    }} />}

    <Accordion
      limit={limit}
      query={relatedQuery}
      params={{ id: current, relatedTo: relatedTo, type: type ? type : [], storyType: storyType }}
      route={`${current}-content-related-to-${relatedTo}-${limit}`}
      buttonClass={!!searchQuery ? "hidden" : "center"}
      sort={true}
    >
      {(data) => {
        if (!data) { return "Loading" }

        const filteredData = searchQuery ?
          data.filter(item => item.title.toLowerCase().includes(searchQuery.toLowerCase()))
          : data;

        return <ul className="grid grid--33">
          {filteredData.map((article, i) => {
            return <li key={article.id}>
              <NewsModule article={article} color={color} />
            </li>
          })
          }
        </ul>
      }}
    </Accordion>
  </section>
}

export const SearchEntries = ({ searchQuery }) => {
  const [search, setSearch] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    searchQuery(search);
  };

  return (
    <form className="search" onSubmit={handleSubmit}>
      <input
        type="text"
        onChange={(e) => setSearch(e.target.value)}
        value={search}
      />
      <button className="button-small blackBorder" type="submit">
        Search
      </button>

      {search !== "" && <button className="button-xs button white" onClick={() => {
        setSearch("")
        searchQuery();
      }}>clear</button>}
    </form>
  );
};